<div>
    <div class="titulo-firmantes-solicitudes">
        <p>{{ 'PERFILCREZCAMOS.LBL_FIRMANTESSOLICITUD' | translate | uppercase }}</p>
        <p>{{ solicitud.numeroCredito ?
            solicitud.numeroCredito
            :solicitud.idSolicitud ?
            solicitud.idSolicitud
            : '-' }}</p>
    </div>
    <p-table class="tabla-gris" [columns]="columnasFirmantes" [value]="listFirmantes" [paginator]="true"
            [rows]="3" [responsive]="true" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="text-center" [attr.colspan]="columns.length">
                    {{ 'PERFILCREZCAMOS.LBL_FIRMANTES' | translate | uppercase }}
                </th>
            </tr>
            <tr class="table-row-white">
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
                {{col.header | uppercase }}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
                <td class="text-center">{{ row.nombreCompleto ? row.nombreCompleto : '-'}}</td>
                <td class="text-center">{{ row.codigoTipoDocumento ? convertirAbreviatura( row.codigoTipoDocumento ) + ' ' : '-'}}{{ row.numeroDocumento ? ( row.numeroDocumento | numero: 0 ) : '-' }}</td>
                <td class="text-center">{{ row.vinculacion ? row.vinculacion : '-'}}</td>
                <td class="text-center">{{ row.parentesco ? row.parentesco : '-'}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td class="text-center" [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                  pButton (click)="cerrarModal()"></button>
        </div>
    </div>
</div>
